module.exports = __webpack_public_path__ + "img/v.fb4e97ea.jpg";